import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogConfig, DialogRef } from '@sag-ui';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-delete-cod-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule, SharedModule],
    templateUrl: './delete-cod.component.html'
})
export class DeleteCodDialogComponent {
    constructor(public config: DialogConfig<{ id: string }>, public dialogRef: DialogRef<string>) {}

    public onClose(result?: string): void {
        this.dialogRef.close(result);
    }
}
